import { Trophy, ListChecks, Activity, StickyNote } from "lucide-react";

export default function StatsBar({ total, filtered, mastered, notesCount = 0 }) {
  const pct = total === 0 ? 0 : Math.round((mastered / total) * 100);
  return (
    <div
      data-testid="stats-bar"
      className="grid grid-cols-2 md:grid-cols-5 gap-px bg-zinc-800 border border-zinc-800"
    >
      <Stat
        label="Total questions"
        value={total}
        icon={<ListChecks className="w-4 h-4" />}
        testid="stat-total"
      />
      <Stat
        label="Affichées"
        value={filtered}
        icon={<Activity className="w-4 h-4" />}
        testid="stat-filtered"
      />
      <Stat
        label="Maîtrisées"
        value={mastered}
        icon={<Trophy className="w-4 h-4" />}
        accent="text-emerald-400"
        testid="stat-mastered"
      />
      <Stat
        label="Notes perso"
        value={notesCount}
        icon={<StickyNote className="w-4 h-4" />}
        accent="text-amber-400"
        testid="stat-notes"
      />
      <Stat
        label="Progression"
        value={`${pct}%`}
        progress={pct}
        testid="stat-progress"
      />
    </div>
  );
}

function Stat({ label, value, icon, accent = "text-sky-400", progress, testid }) {
  return (
    <div
      data-testid={testid}
      className="bg-zinc-950 px-5 py-4 flex flex-col gap-2 relative overflow-hidden"
    >
      <div className="flex items-center justify-between">
        <span className="text-[10px] uppercase tracking-[0.25em] text-zinc-500">
          {label}
        </span>
        <span className={`${accent}`}>{icon}</span>
      </div>
      <div className={`font-display text-3xl font-bold ${accent}`}>{value}</div>
      {progress !== undefined && (
        <div className="w-full h-1 bg-zinc-800 mt-1">
          <div
            className="h-full bg-emerald-500 transition-all duration-500"
            style={{ width: `${progress}%` }}
          />
        </div>
      )}
    </div>
  );
}
